module.exports = __webpack_public_path__ + "static/media/MathDetailsScreen_elGrade5512_play_icon_112853.130371fa.jpg";